import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { UserPreferenceService } from '../services/user.preferences.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/first';

@Injectable()
export class DashboardResolve implements Resolve<Object> {

  constructor(private userPreference: UserPreferenceService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    console.log('Going through resolve ..... ');
    return null;
  }
}